module.exports = __webpack_public_path__ + "CC_spring_leaf.202f04a42c3065908769.png";


//////////////////
// WEBPACK FOOTER
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/assets/CC_spring_leaf.png
// module id = ../../../../../src/assets/CC_spring_leaf.png
// module chunks = main